import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { getEverplansTierText } from '@/classes/SubmissionStatuses/statusUtils'

export class PendingStatus extends BaseEverplansStatus {
	getStatusText() {
		return this.submissionStatus.requestedAccountTier
			? getEverplansTierText(this.submissionStatus.requestedAccountTier) +
					' / Pending'
			: 'Pending'
	}

	getToolTipText() {
		return {
			title: this.getStatusText(),
			body:
				'This packet is pending submission to ' +
				this.getVendorName() +
				' and will update once completed. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.PENDING
	}
}
